
export const frontSkillsList = [
  {
    label: "HTML5",
    src: "https://img.icons8.com/color/480/000000/html-5--v1.png",
  },
  {
    label: "CSS3",
    src: "https://img.icons8.com/color/480/000000/css3.png",
  },
  {
    label: "Javascript",
    src: "https://img.icons8.com/color/480/000000/javascript.png",
  },
  {
    label: "React",
    src: "https://img.icons8.com/color/480/000000/react-native.png",
  },
  {
    label: "Redux",
    src: "https://img.icons8.com/color/480/000000/redux.png",
  },
  {
    label: "Chakra UI",
    src: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
  },
  {
    label: "Bootstrap",
    src: "https://i.ibb.co/zx0Tt9M/bootstrap.png",
  },
  {
    label: "NPM",
    src: "https://img.icons8.com/color/480/000000/npm.png",
  },
];

export const backSkillsList = [
  {
    label: "HTML5",
    src: "https://img.icons8.com/color/480/000000/html-5--v1.png",
  },
  {
    label: "CSS3",
    src: "https://img.icons8.com/color/480/000000/css3.png",
  },
  {
    label: "Javascript",
    src: "https://img.icons8.com/color/480/000000/javascript.png",
  },
  {
    label: "React",
    src: "https://img.icons8.com/color/480/000000/react-native.png",
  },
  {
    label: "Redux",
    src: "https://img.icons8.com/color/480/000000/redux.png",
  },
  {
    label: "Chakra UI",
    src: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
  },
  {
    label: "Bootstrap",
    src: "https://i.ibb.co/zx0Tt9M/bootstrap.png",
  },
  {
    label: "NPM",
    src: "https://img.icons8.com/color/480/000000/npm.png",
  },
  {
    label: "Node JS",
    src: "https://img.icons8.com/color/480/000000/nodejs.png",
  },
  {
    label: "Express JS",
    src: "https://i.ibb.co/9smDM6j/pngegg.png",
  },
  {
    label: "Mongo dB",
    src: "https://i.ibb.co/ZVh01dm/rsz-mong2.png",
  },
  {
    label: "Heroku",
    src: "https://cdn-icons-png.flaticon.com/512/873/873120.png"
  }
];


